import { TblBidDataDisplay } from "../../models/BidDataDisplay";

export class AddCurrentBidData {
  static readonly type = "[CurrentBidData] Add";
  constructor(public payload: TblBidDataDisplay) {}
}

export class RemoveCurrentBidData {
  static readonly type = "[CurrentBidData] Remove";
  constructor() {}
}
